import util from "@/util";
import $api from "@/api";
import moment from "@/moment-gp.js";
import firebase from "@firebase/app";
import { OPTIMIZER_RUNS_LOCALLY } from "@/features";
import $models from "@/models";
//import clonedeep from 'lodash.clonedeep'

//import FWorker from '@/workers/FWorker.js'
//import OptimizerWebWorker from '@/workers/optimizer_web_worker.js'

// eslint-disable-next-line
import OptimizerWebWorker from "worker-loader!@/workers/optimizer_web_worker.js";

const log1 = (...args) => {
  console.log(...args);
};
const log2 = (...args) => {
  console.log(...args);
};

const OPTIMIZER_DRY_RUN = false;

/* ================================ Actions ================================= */

const worker = OptimizerWebWorker();
worker.onmessage = event => {
  if (event.data.status === "ready") {
    $api.set_ready("optimizer_worker");
  }
};

export function optimizer_onload({ commit }) {
  // console.log("optimizer_onload");
}

// -----------------------------------------------------------------------------
export function optimizer_trigger(
  { commit, dispatch, state, rootGetters },
  {
    // planning_horizon,
    prediction_mode,
    commitmentId /* only required if prediction_mode == true */
  } = {}
) {
  if (rootGetters["app/OPTIMIZER_DISABLE"]) {
    console.log(
      "[optimizer] Disabled ... turn on via dev menu and F5 to update cookie"
    );
    return;
    // TODO: Allow manual trigger?
  }

  log1("[optimizer] Running optimizer ...");

  /* Make sure prediction_mode is boolean (and false if not set) */
  prediction_mode = !!prediction_mode;

  // if (!planning_horizon) {
  let planning_horizon = state.optimizer_planning_horizon;
  // }

  log2("[optimizer] planning_horizon.", planning_horizon);
  if (!util.isNumeric(planning_horizon)) {
    throw new Error("Inavlid planning horizon", planning_horizon);
  }

  commit("SET_OPTIMIZER_STATE", "running");
  commit("SET_OPTIMIZER_USER_ERROR", null);

  let user_timezone = $models.userSettings.getters.user_get_timezone;
  let user_settings = $models.userSettings.getNode($models.user.defaultUserId);
  let user_workmode_settings = user_settings.workmodeSettings || {};
  let existing_events =
    rootGetters["calendar/calendar_existing_events_for_optimizer"]; // TODO NO ()
  let recorded_sessions_promise =
    $models.taskRecordedSession.getters.get_recorded_sessions_all_goals;
  let timeslot_collection_list_promise = $models.timeslotCollection.getList(); // clonedeep($models.timeslotCollection.getList().itemsAsArray())
  let timeslot_collection_list = timeslot_collection_list_promise
    .itemsAsArray()
    //.filter(item => !item.deleted || item.deleted === false)
    .map(tsc => {
      return {
        tscId: tsc.$id,
        name: tsc.$state.name,
        color: tsc.$state.color,
        sortidx: tsc.$state.sortidx
      };
    });

  let commitment_list = $models.commitment.getters.commitment_list_all
    //.filter(commitment => commitment.user.timeslotCollectionId && commitment.user.timeslotCollectionId !== '' && commitment.active && !commitment.meta.deleted)
    .map(commitment => {
      return {
        commitmentId: commitment.commitmentId,
        name: commitment.meta.name,
        tscId: commitment.user.timeslotCollectionId,
        goalId: commitment.goalId
      };
    });
  let recorded_sessions = Object.keys(recorded_sessions_promise).map(goalId => {
    let goal = recorded_sessions_promise[goalId];
    return goal.map(recorded_session => {
      return {
        from: recorded_session.$id,
        duration: recorded_session.duration,
        taskId: recorded_session.taskId,
        commitmentId: recorded_session.commitmentId,
        goalId: goalId
      };
    });
  });

  log2("[optimizer] user_timezone", user_timezone);
  log2("[optimizer] user_workmode_settings", user_workmode_settings);
  log2("[optimizer] existing_events", existing_events);

  /* Test: is optimizer input really ready? */
  let ready_code =
    1 * $api.get_ready("timeslot_worker") +
    2 * $api.get_ready("optimizer_worker") +
    4 * $api.get_ready("optimizer_input");

  if (ready_code !== 7) {
    console.warn("[optimizer] not ready. Code: ", ready_code);
    commit("SET_OPTIMIZER_STATE", "waiting");
    return;
  }

  /* Get optimizer input */
  let optimizer_payload = rootGetters["optimizer/optimizer_input"];
  log2("[optimizer] optimizer_payload", optimizer_payload);

  if (OPTIMIZER_DRY_RUN) {
    commit("SET_OPTIMIZER_STATE", "success");
    return;
  }

  /* Get dayplan (HACK!) */
  let manual_dayplan = optimizer_payload['DAYPLAN'];
  delete optimizer_payload['DAYPLAN']

  let wakeup_and_sleep_time = { // TODO UI
    1: { wakeup: 6 * 3600, sleep: 23 * 3600 }, // iso weekday monday
    2: { wakeup: 7 * 3600, sleep: 23 * 3600 },
    3: { wakeup: 7 * 3600, sleep: 23 * 3600 },
    4: { wakeup: 7.5 * 3600, sleep: 23 * 3600 },
    5: { wakeup: 7 * 3600, sleep: 27 * 3600 },
    6: { wakeup: 9 * 3600, sleep: 26 * 3600 },
    7: { wakeup: 6 * 3600, sleep: 22 * 3600 } // iso weekday sunday
  }

  if (OPTIMIZER_RUNS_LOCALLY) {
    /* ---------------------- Run optimizer locally --------------------- */

    let message = {
      planning_horizon: planning_horizon,
      user_timezone_name: user_timezone,
      tsc_config: optimizer_payload,
      first_day_of_week: 0, // 0 = monday
      existing_events: existing_events,
      workmode_settings: user_workmode_settings,
      recorded_sessions: recorded_sessions,
      timeslot_collection_list: timeslot_collection_list,
      commitment_list: commitment_list,
      manual_dayplan: manual_dayplan,
      wakeup_and_sleep_time: wakeup_and_sleep_time
    };

    log2("[optimizer:worker] *** Optimizer input message", message);
    worker.postMessage(message);
    //util.saveJSON(message, "optimizer_input.json");

    worker.onmessage = event => {
      log2("[optimizer:worker] *** Got message from worker", event.data.json);

      // store prediction data in goal so that other users can see them
      if (event.data.json.prediction) {
        // save end date : TODO: save into compressed array
        event.data.json.prediction.forEach(prediction => {
          /*let estimatedLastSessionEnd = prediction.lastSessionEnd
          $models.commitment
          .with({
            goalId: prediction.goalId
          })
          .update(prediction.commitmentId, { estimatedLastSessionEnd : estimatedLastSessionEnd })*/
          if (
            prediction.goalId &&
            prediction.commitmentId &&
            event.data.json.finishDatesByCommitmentSerialized[ prediction.commitmentId ]
          ) {
            //console.log('prediction.goalId', prediction.goalId, 'prediction.commitmentId', prediction.commitmentId)
            let myPrivacySettings = $models.goalMemberPrivacySettings
              .with({
                goalId: prediction.goalId,
                memberId: $models.user.defaultUserId
              })
              .getData();

            // console.log('marker X goalId',prediction.goalId,  myPrivacySettings["TEAM"].allow_to_see_enddates)
            if (myPrivacySettings["TEAM"].allow_to_see_enddates) {
              $models.commitmentTaskFinishDates
                .with({
                  goalId: prediction.goalId
                })
                .update(prediction.commitmentId, {
                  finishDatesArray:
                    event.data.json.finishDatesByCommitmentSerialized[ prediction.commitmentId ]
                });
            } else {
              $models.commitmentTaskFinishDates
                .with({
                  goalId: prediction.goalId
                })
                .remove(prediction.commitmentId);
            }
          }
        });
      }

      commit("RESET_MASKED_EVENTS");
      commit("SET_OPTIMIZER_STATE", "success");
      commit("SET_OPTIMIZER_RESULT", event.data.json);
      //commit('SET_OPTIMIZER_RESPONSE_TIME', response_time);
    };

    worker.onerror = user_error => {
      commit("SET_OPTIMIZER_STATE", "fail");
      commit("SET_OPTIMIZER_USER_ERROR", user_error.message);

      console.warn("[optimizer:worker] ERROR", user_error);
    };
  } else {
    /* ----------------- Run optimizer in cloud function ---------------- */

    let optimizer_settings = {
      planning_horizon: planning_horizon,
      user_timezone_iso: user_timezone
        ? moment
            .tz(user_timezone)
            .format()
            .substr(-6)
        : "Z",
      user_timezone_offset: moment.tz(user_timezone).utcOffset(),
      user_timezone_name: user_timezone,
      optimizer: state.optimizer_algorithm,
      optimizer_payload: optimizer_payload,
      existing_events: existing_events
    };
    if (prediction_mode) {
      optimizer_settings = Object.assign(
        {
          prediction_mode: true,
          commitmentId: commitmentId
        },
        optimizer_settings
      );
    }

    const cloud_function_url =
      "https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-1024-http";

    // const cloud_function_url = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-256-http';

    /*if (planning_horizon >= 1) {
      cloud_function_url = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-2048-http';
    }*/

    return dispatch("optimizer_call_cloudfunction", {
      url: cloud_function_url,
      optimizer_settings
    })
      .then(({ json, response_time }) => {
        commit("RESET_MASKED_EVENTS");
        commit("SET_OPTIMIZER_STATE", "success");
        commit("SET_OPTIMIZER_RESULT", json);
        commit("SET_OPTIMIZER_RESPONSE_TIME", response_time);

        log2("[optimizer:cloud] optimizer_result_data", json);
      })
      .catch(user_error => {
        commit("SET_OPTIMIZER_STATE", "fail");
        commit("SET_OPTIMIZER_USER_ERROR", user_error);
      });
  }
}

// -----------------------------------------------------------------------------
export function optimizer_call_cloudfunction(
  context,
  { url, optimizer_settings }
) {
  return new Promise((resolve, reject) => {
    let optimizer_start_time = performance.now();

    // When fetch failes optimization should be set to false after 15 seconds
    let timeoutWatcher = setTimeout(() => {
      let user_error = "A problem occured. No results after 2 minutes.";
      reject(user_error);
    }, 120000);

    let handleError = (msg, error) => {
      let user_error = msg ? msg + "\n" + error : null;
      clearTimeout(timeoutWatcher);
      reject(user_error);
    };

    firebase
      .auth()
      .currentUser.getIdToken(false) // forceRefresh?
      .then(idToken => {
        console.log(
          "[Optimizer] Got auth token: ",
          idToken.substring(0, 10),
          "..."
        );

        fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          headers: {
            Authorization: "Bearer " + idToken,
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(optimizer_settings)
        })
          .then(response => {
            console.log("[Optimizer] Got response:", response);
            // this.optimization_running = false;
            let optimizer_end_time = performance.now();
            let response_time = optimizer_end_time - optimizer_start_time;

            response
              .json()
              .then(json => {
                console.log("[Optimizer] Got JSON:", json);
                clearTimeout(timeoutWatcher);
                resolve({ json, response_time });
              })
              .catch(error => {
                console.log("[Optimizer] Failed to read JSON", error);
                handleError("Failed to read server response.", error);
              });
          })
          .catch(error => {
            console.log("[Optimizer] Fetch error:", error);
            handleError("Failed to reach optimization server.", error);
          });
      })
      .catch(error => {
        console.error("Can't not get JWT auth token:", error);
        handleError("Failed to get authorization token.", error);
      });
  });
}

// -----------------------------------------------------------------------------
export function optimizer_run_legacy({ commit, rootState, rootGetters }) {
  console.log("**** optimizer_run ****");
  /* Input:
    =======
    TODO: Perönliche Task-Einstellungen + funFactor (/users/{userId}/private/userdata.tasks)
      (funFactor wird noch nicht in DB gespeichert)
      (Perönliche Task-Einstellungen wird noch nicht in user gespeichert)
    [X] Persönliche Goal-Einstellungen / commitement (/users/{userId}/private/userdata.lanes)
    [X] Goals (/project/{projectId})
    [X] Tasks (/project/{projectId}.items) + manuelle verschobene tasks
    [X] Manuell terminierte tasks (users.{userId}.calendar_items.{calendarweek})
    [X] Verfügbarkeits-Einstellungen (/users/{userId}/private/userdata.availabilitySettings)
    [X] Pausen-Einstellungen (/users/{userId}/private/userdata.workmodeSettings)
    TODO: Trello Tasks
    TODO: Schon belegten Zeiten (via Google Calendar)
  */

  return new Promise((resolve, reject) => {
    let optimizerInput = {};
    optimizerInput.currentWeek = moment().format("W");
    console.log("[OPT] currentWeek", optimizerInput.currentWeek);

    optimizerInput.userData = rootGetters["user/userData"];
    console.log("[OPT] userData", optimizerInput.userData);

    optimizerInput.availabilitySettings =
      optimizerInput.userData.availabilitySettings;
    console.log(
      "[OPT] availabilitySettings",
      optimizerInput.availabilitySettings
    );

    optimizerInput.workmodeSettings = optimizerInput.userData.workmodeSettings;
    console.log("[OPT] workmodeSettings", optimizerInput.workmodeSettings);

    optimizerInput.projectListUser =
      rootGetters["project/project_list_with_details"];
    console.log("[OPT] projectListUser", optimizerInput.projectListUser);

    optimizerInput.projectList = {};
    Object.keys(optimizerInput.projectListUser).forEach(project_id => {
      // doppelt
      // let sortedGoals = rootGetters["project/sorted_goals"](project_id);
      // console.log("[OPT] sortedGoals[", project_id, "]", sortedGoals);

      let projectData = rootGetters["project/project_by_id"](project_id);
      console.log("[OPT] projectData[", project_id, "]", projectData);
      optimizerInput.projectList[project_id] = projectData;
    });

    optimizerInput.eventList = rootGetters["calendar/events_by_calendarweek"](
      optimizerInput.currentWeek
    ); // TODO - no week
    console.log("[OPT] eventList", optimizerInput.eventList);

    optimizerInput.markerList = rootGetters["calendar/markers_by_calendarweek"](
      optimizerInput.currentWeek
    ); // TODO - no week
    console.log("[OPT] markerList", optimizerInput.markerList);

    console.log("[OPT] ALL INPUTS", optimizerInput);
    // console.log("[OPT] ALL INPUTS", JSON.stringify(optimizerInput));

    setTimeout(() => {
      resolve();
    }, 2000);
  });
}

// -----------------------------------------------------------------------------
export function optimizer_autoplan_new_task(
  { commit },
  { preference, duration }
) {
  console.warn("LEGACY CODE");

  duration = duration || 60;

  const timezone = "02:00"; // HACK
  function createTime(h, m = 0) {
    // DEPRECATED
    let today = moment()
      .toISOString(true)
      .split("T")[0];

    // TODO: move to util
    h = h > 9 ? "" + h : "0" + h;
    m = m > 9 ? "" + m : "0" + m;
    return today + "T" + `${h}:${m}` + "+" + timezone;
    // return today + 'T' + `${h}:${m}` + '+' + today.getTimezoneOffset();
  }

  let data = {
    group: "today",
    start: createTime(12, 0),
    end: null
  };

  switch (preference) {
    case "TODAY":
      data.group = "today";
      break;
    case "EVENING":
      data.group = "today";
      data.start = createTime(18, 0);
      break;
    case "TOMORROW":
      data.group = "tomorrow";
      break;
  }

  data.end = moment(data.start)
    .add(duration, "m")
    .toISOString(true);
  return data;
}

// -----------------------------------------------------------------------------
export function optimizer_live_update_while_dragging({ commit }) {
  console.warn("LEGACY CODE");
  return "NOT_IMPLEMENTED";
}

// -----------------------------------------------------------------------------
export function optimizer_set_planning_horizon(
  { commit },
  { planning_horizon }
) {
  commit("SET_PLANNING_HORIZON", { planning_horizon: planning_horizon });
}

// -----------------------------------------------------------------------------
export function optimizer_set_manual_dayplan(
  { commit },
  { date, dayplan }
) {
  commit('SET_MANUAL_DAYPLAN', { date: date, dayplan: dayplan })
}
